import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { Link } from 'react-router-dom';
import AdvancedListSearch from '../../../common/RaaLists/AdvancedListSearch/AdvancedListSearch';
import RenderAlertLimitReached from '../../../alerts/AlertLayout/RenderAlertLimitReached/RenderAlertLimitReached';
import SearchType from '../../../../utility/types/SearchType';
import { fetchSavedSearches } from '../../../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import { selectActiveSubscriptionCounts } from '../../../../redux/slices/sessionSlice';
import DeviceListTable from '../DeviceListTable/DeviceListTable';
import {
  fetchFilteredDeviceList,
  selectDeviceListCrudStatus,
  setDeviceListPage,
} from '../../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';
import { CrudStatus } from '../../../../utility/types/CrudStatus';
import { RaaRoles } from '../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../highorder/HasRolePrivileges';

const DeviceListLayout = () => {
  const dispatch = useDispatch();
  const activeSubscriptionCounts = useSelector(selectActiveSubscriptionCounts);
  const { deviceLimit, deviceCount } = activeSubscriptionCounts;
  const deviceListCrudStatus = useSelector(selectDeviceListCrudStatus);

  const [error, setError] = useState(deviceListCrudStatus === CrudStatus.ERROR);

  const isLimitReached = deviceCount >= deviceLimit;

  const fetchFilteredDevices = (filters) => {
    setError(false);
    dispatch(fetchFilteredDeviceList({ filters }));
  };

  const handleDismissError = () => {
    setError(false);
  };

  useEffect(() => {
    dispatch(fetchSavedSearches(SearchType.DEVICE));
  }, []);

  return (
    <>
      <div className="row">
        <div className="col">
          <h2 className="mb-0">
            Devices
            <a
              title="Register Devices FAQ"
              rel="noopener noreferrer"
              target="_blank"
              href="https://avtech.com/articles/42/add-devices-roomalert-com-account-video/"
              className="text-muted small"
            >
              {' '}
              <span style={{ fontSize: 'smaller' }}>
                <Icon icon="circle-question" size="xs" />
              </span>
            </a>
          </h2>
        </div>
        <div className="col text-right">
          <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
            <Link to="/devices/register-device">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => window.location.assign('/devices/register-device')}
              >
                Register Device
              </button>
            </Link>
          </HasRolePrivileges>
        </div>
      </div>
      <div className="mb-4">
        <span className={`text-muted small ${isLimitReached ? 'text-danger' : ''}`}>
          {`${deviceCount} ${deviceCount === 1 ? 'device' : 'devices'}`}
          {Number(deviceLimit) === 1000000 ? null : ` (of ${deviceLimit} allowed)`}
          {isLimitReached && <RenderAlertLimitReached />}
        </span>

      </div>
      <hr />
      <div>
        {error && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={handleDismissError}>
                Unexpected Error retrieving devices.
              </ErrorBanner>
            </div>
          </div>
        )}
        {deviceCount > 0 ? (
          <>
            <AdvancedListSearch
              searchType={SearchType.DEVICE}
              getSearchedResults={fetchFilteredDevices}
              setListCurrPage={() => dispatch(setDeviceListPage(0))}
            />
            <DeviceListTable />
          </>
        )
          : (
            // eslint-disable-next-line react/react-in-jsx-scope
            <></>
          )}
      </div>
    </>
  );
};

export { DeviceListLayout };
export default DeviceListLayout;
